import { Checkbox, Inline } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { CHECKED_BAGGAGE_INCLUDED } from '../../../../../constants/searchFiltersConstants';
import Filter from '../Filter';
import type { Filters } from './MobileFilters';

interface CheckedBaggageProps {
  className: string;
  isInitiallyExpanded: boolean;
  isToggleable: boolean;
  onFilter: (filterOptions: { [key: string]: null | string }) => void;
  selectedFilters?: Filters | null;
}

const CheckedBaggage = ({
  className,
  isInitiallyExpanded,
  isToggleable,
  onFilter,
  selectedFilters,
}: CheckedBaggageProps) => {
  const { t } = useTranslation();
  const handleChange = () =>
    selectedFilters && selectedFilters[CHECKED_BAGGAGE_INCLUDED]
      ? onFilter({ [CHECKED_BAGGAGE_INCLUDED]: null })
      : onFilter({ [CHECKED_BAGGAGE_INCLUDED]: 'true' });

  return (
    <Filter
      className={className}
      isInitiallyExpanded={isInitiallyExpanded}
      isToggleable={isToggleable}
      label={t('Result.SearchFilters.CheckedBaggage.Text')}
      name={CHECKED_BAGGAGE_INCLUDED}
    >
      <Inline alignY="top" noWrap spacing={8}>
        <Checkbox
          checked={Boolean(selectedFilters && selectedFilters[CHECKED_BAGGAGE_INCLUDED])}
          id="checkedBaggage-checkbox"
          name={CHECKED_BAGGAGE_INCLUDED}
          onChange={handleChange}
          value={(selectedFilters && selectedFilters[CHECKED_BAGGAGE_INCLUDED]) ?? 'false'}
        />
        <Checkbox.Label htmlFor="checkedBaggage-checkbox">
          {t('Result.SearchFilters.CheckedBaggage.Option.Label')}
        </Checkbox.Label>
      </Inline>
    </Filter>
  );
};

export default CheckedBaggage;
